import { Header } from "../../components/Header";
import "swiper/swiper-bundle.css";
import { useState } from "react";
import { BsGithub } from "react-icons/bs";
import { SiLinkedin } from "react-icons/si";
import { BsDiscord } from "react-icons/bs";
import { MdOutlineMailOutline } from "react-icons/md";
import { Badge } from "../../components/Badge";
import { Project } from "../../components/Project";
import { ProjectModal } from "../../components/ProjectModal";
import Fade from "react-reveal/Fade";
import { Timeline } from "../../components/Timeline";
import { Card } from "../../components/Card";
import {
	Container,
	Main,
	PresentationSection,
	Info,
	Greetings,
	H1,
	Subtitle,
	KnowMeBetterContainer,
	MyProjectsSection,
	Carousel,
	MySummary,
	Text,
	TechnologiesSection,
	TechList,
	Item,
	Contact,
	GithubButton,
	WhoIAmSection,
	TimelineSection,
	ContactContent,
	FooterTitle,
	FooterInfo,
	FooterMyContact,
	PortfolioSummary,
	ProfilePicture,
	ProfilePictureContainer,
	CommingSoon,
	Box,
} from "./styles";
import { ContactList } from "../../components/ContactList";

export function Home({ projects, technologiesBackend, technologiesFrontend, technologiesMainframe, softSkills, profilePicture, presentationText, databases }) {
	const [activeProject, setActiveProject] = useState({});
	const [isModalOpen, setIsModalOpen] = useState(false);

	return (
		<Container>
			<Header />
			<Main>
				<PresentationSection>
					<Info>
						<Greetings>
							Olá! Eu sou David, <br /> desenvolvedor Web <br /> com foco em backend
						</Greetings>
						<Subtitle>
							Estou em constante aprendizado nas tecnologias backend <br /> e busco sempre dar o meu melhor ao fazer aquilo que amo: programar!
						</Subtitle>
						<ContactList />
					</Info>
					<KnowMeBetterContainer>

					</KnowMeBetterContainer>
				</PresentationSection>

				<Fade>
					<>
						<WhoIAmSection>
							<MySummary id="who-i-am">
								<H1 size="3rem">
									Quem sou eu
								</H1>
								<Text>
									{presentationText}
								</Text>
								<ProfilePictureContainer>
									<ProfilePicture src={profilePicture} alt="" />
								</ProfilePictureContainer>
							</MySummary>
						</WhoIAmSection>
						<TechnologiesSection>
							<Box>
								<TechList>
									<li>
										<h1>
											Frontend/Mobile
										</h1>
									</li>
									{technologiesFrontend?.map((tech, i) => (
										<Item key={i}>
											{tech.icon}
											<p>{tech.name}</p>
										</Item>
									))}
								</TechList>
								<TechList>
									<li>
										<h1>
											Backend
										</h1>
									</li>
									{technologiesBackend?.map((tech, i) => (
										<Item key={i}>
											{tech.icon}
											<p>{tech.name}</p>
										</Item>
									))}
								</TechList>
								<TechList>
									<li>
										<h1>
											Mainframe
										</h1>
									</li>
									{technologiesMainframe?.map((tech, i) => (
										<Item key={i}>
											{tech.icon}
											<p>{tech.name}</p>
										</Item>
									))}
								</TechList>
								<TechList>
									<li>
										<h1>
											Databases
										</h1>
									</li>
									{databases?.map((tech, i) => (
										<Item key={i}>
											{tech.icon}
											<p>{tech.name}</p>
										</Item>
									))}
								</TechList>
								<TechList>
									<li>
										<h1>
											Soft skills
										</h1>
									</li>
									{softSkills?.map((tech, i) => (
										<Item key={i}>
											{tech.icon}
											<p>{tech.name}</p>
										</Item>
									))}
								</TechList>
							</Box>
						</TechnologiesSection>
					</>
				</Fade>


				<Fade>
					<MyProjectsSection id="my-projects">
						<H1 size={"3rem"}>
							Portfólio
						</H1>
						<PortfolioSummary>
							Aqui estão alguns de meus melhores projetos
						</PortfolioSummary>
						<Carousel>
							{projects?.map((project, i) => (
								<Project
									{...project}
									setProject={setActiveProject}
									setIsModalOpen={setIsModalOpen}
									key={i}
								/>
							))}
							<CommingSoon>
								<h2>
									Mais projetos aqui em breve!
								</h2>
							</CommingSoon>
						</Carousel>
						<GithubButton>
							<a href="https://github.com/DavidEsdrs" target="_blank" rel="noreferrer">
								<BsGithub fill="#fff" />
								visite meu github
							</a>
						</GithubButton>
					</MyProjectsSection>
				</Fade>

				<TimelineSection>
					<H1 size={"3rem"}>
						Meu aprendizado
					</H1>
					<Timeline gap={"10px"} middleWidth={"20px"}>
						<Fade>
							<Card
								grade={"tecnólogo"}
								title={"Análise e Desenvolvimento de Sistemas"}
								text={"IFPE | 2023 - 2026"}
								type={"geral"}
								tags={[
									{ name: "lógica da programação", color: "#fa7f72" },
									{ name: "banco de dados", color: "#fa7f72" },
								]}
								color={"#fa7f72"}
							/>
						</Fade>
						<Fade>
							<Card
								grade={"curso"}
								title={"Microsservices with NodeJs and ReactJs"}
								text={"Stephen Grider - Udemy | 2023 -"}
								type={"fullstack"}
								tags={[
									{ name: "microsservices", color: "#fa7f72" },
									{ name: "nodejs", color: "#fa7f72" },
									{ name: "react", color: "#fa7f72" },
								]}
								color={"#fa7f72"}
							/>
						</Fade>
						<Fade>
							<Card
								grade={"curso"}
								title={"ReactJs e NextJs"}
								text={"Luiz Otávio Miranda - Udemy | 2023 -"}
								type={"fullstack"}
								tags={[
									{ name: "react", color: "#fa7f72" },
									{ name: "next", color: "#fa7f72" },
								]}
							/>
						</Fade>
						<Fade>
							<Card
								grade={"curso"}
								title={"Banco de Dados e SQL"}
								text={"Felipe Mafra - Udemy | 2022 -"}
								type={"database"}
								tags={[
									{ name: "sql", color: "#fa7f72" },
									{ name: "mysql", color: "#fa7f72" },
								]}
							/>
						</Fade>
						<Fade>
							<Card
								grade={"técnico"}
								title={"Programação de Jogos digitais"}
								text={"NAVE Cícero Dias | 2020 - 2022"}
								type={"geral"}
								tags={[
									{ name: "c#", color: "#fa7f72" },
									{ name: "unity", color: "#fa7f72" },
									{ name: "poo", color: "#fa7f72" },
								]}
							/>
						</Fade>
					</Timeline>
				</TimelineSection>

				<Contact id="contact-me">
					<ContactContent>
						<FooterInfo>
							<FooterTitle size="4">
								David Esdras
							</FooterTitle>
						</FooterInfo>
						<FooterMyContact>
							<h2>
								Meus contatos
							</h2>
							<ul>
								<li>
									<p>
										email davidesdrasfdev@gmail.com
									</p>
								</li>
								<li>
									<p>
										linkedin davidesdras
									</p>
								</li>
								<li>
									<p>
										github DavidEsdrs
									</p>
								</li>
							</ul>
						</FooterMyContact>
					</ContactContent>
					<ul>
						<Badge name="Linkedin" href="https://www.linkedin.com/in/davidesdras/" backgroundColor={"#0077B5"} icon={<SiLinkedin size={"2rem"} style={{ fill: "white" }} />} />
						<Badge name="Discord" href="https://discordapp.com/channels/@me/dav#3959" backgroundColor={"#7289DA"} icon={<BsDiscord size={"2rem"} style={{ fill: "white" }} />} />
						<Badge name="Email" href="mailto:davidesdrasfdev@gmail.com" backgroundColor={"#D93025"} icon={<MdOutlineMailOutline size={"2rem"} style={{ fill: "white" }} />} />
						<Badge name="Github" href="https://github.com/DavidEsdrs" backgroundColor={"#0d1117"} icon={<BsGithub size={"2rem"} style={{ fill: "white" }} />} />
					</ul>
				</Contact>
			</Main>
			<ProjectModal {...activeProject} isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen} />
		</Container>
	);
}